export default (function (context) {
  return {
    colour: {
      warnLight: context.colour.brandYellowLight,
      warnDark: context.colour.brandYellow,
      errorLight: context.colour.brandOrangeLight,
      errorDark: context.colour.brandOrangeDark,
      error: context.colour.brandOrange,
      successLight: context.colour.brandGreenLight,
      successDark: context.colour.brandGreen,
      infoLight: context.colour.brandAquaLight,
      infoDark: context.colour.brandAqua
    }
  };
});